const simple5StagePath = [
    {
        label: "IF",
        role: "IF",
        input: null,
        output: "IF/ID",
        latency: 1,
        canDelay: true
    },
    {
        label: "ID",
        role: "ID",
        input: "IF/ID",
        output: "ID/EX",
        latency: 1,
        canDelay: true
    },
    {
        label: "EX",
        role: "EX",
        input: "ID/EX",
        output: "EX/MEM",
        latency: 1,
        canDelay: true
    },
    {
        label: "MEM",
        role: "MEM",
        input: "EX/MEM",
        output: "MEM/WB",
        latency: 1,
        canDelay: false
    },
    {
        label: "WB",
        role: "WB",
        input: "MEM/WB",
        output: null,
        latency: 1,
        canDelay: false
    }          
];

const simple5phase = {
    name: "Egyszerű, 5 fokozatú",
    paths: {
        "int*": {
            phases: simple5StagePath,
            opARequired: "EX",
            opBRequired: "EX",
            targetProvided: "EX",
            registerWriteBack: "WB",
            registerReadOut: "ID"
        },
        "mem*": {
            phases: simple5StagePath,
            opARequired: "EX",
            opBRequired: "MEM",
            targetProvided: "MEM",
            registerWriteBack: "WB",
            registerReadOut: "ID"
        },
        "jump*": {
            phases: simple5StagePath,
            opARequired: "",
            opBRequired: "EX",
            targetProvided: "",
            registerWriteBack: "",
            registerReadOut: "ID"         
        }
    },
    description: "A pipeline megegyezik az órán tanult egyszerű, 5 fokozatú pipeline-al. Az IF fázis betölti az utasítást, "
        +"az ID dekódolja és betölti a regiszter operandusokat. Az EX aritmetikai és logikai műveleteket végez "
        +"(memóriaműveletek esetén a címet számolja, ugrás esetén pedig kiértékeli az igrási címet és ugrási feltételt). "
        +"A MEM a load/store utasításokat végrehajtja, a WB pedig visszaírja az eredményt a regisztertárolóba. "
        +"A pipeline minden fázisa képes utasítást várakoztatni, minden forwarding út használata megengedett."
};

export default simple5phase;